<template>
  <div style="position:relative">
    <!-- 遮罩 -->
    <div class="zhezhao" v-if="issetDefault || isOpensaas || isNoopen || isokopensaas"></div>
    <!-- 设置默认弹窗 -->
    <div class="tanchuang szmoren" v-if="issetDefault">
      <div class="over">
        <img @click="guanbitc" class="right xs" src="/static/img/qiye/chahao.png" alt />
      </div>
      <div v-if="isDefault">
        <div class="tc-text tc-queren">
          <span>是否确认设为默认企业？</span>
        </div>
        <div class="tc-anniu">
          <button @click="setDefault">确认</button>
          <button @click="guanbitc">取消</button>
        </div>
      </div>
      <div v-else>
        <div class="tc-conent">
          <img src="/static/img/qiye/dengji@1x.png" alt />
        </div>
        <div class="tc-text">
          <span>已设为默认企业</span>
        </div>
      </div>
    </div>
    <!-- 开通sass服务弹窗 -->
    <div class="tanchuang ktsass" v-if="isOpensaas">
      <div class="over">
        <img @click="guanbitc" class="right xs" src="/static/img/qiye/chahao.png" alt />
      </div>
      <div v-if="ktsass">
        <div class="tc-text tc-queren">
          <span>是否确认开通saas服务？</span>
        </div>
        <div class="tc-anniu">
          <button @click="confirmSaas">确认</button>
          <button @click="guanbitc">取消</button>
        </div>
      </div>
      <div v-else>
        <div class="tc-text tc-conent">
          <span>开通成功</span>
        </div>
        <div style="margin-top: 40px;">
          <span @click="showServeWin" class="gs-btn1 dianji">进入服务</span>
        </div>
      </div>
    </div>
    <!-- 该企业已开通服务弹窗 -->
    <div class="tanchuang qy-yikaitong" v-if="isokopensaas" style="width: 493px;height: 264px;">
      <div class="over">
        <img @click="guanbitc" class="right xs" src="/static/img/qiye/chahao.png" alt />
      </div>
      <div>
        <div class="tc-okkaitong">
          <span>该企业已开通服务</span>
        </div>
        <div class="tc-context">
          <p>进入服务方式一：可通过添加企业中加入企业申请，待管理员批准通过</p>
          <p>进入服务方式二：联系管理员邀请加入</p>
          <p>
            <span>saas服务管理员：</span>
            <span>{{admin}}</span>
          </p>
          <p>
            <span>saas服务管理员手机号：</span>
            <span>{{adminMobile}}</span>
          </p>
          <p>
            <span>saas服务管理员邮箱：</span>
            <span></span>
          </p>
        </div>
      </div>
    </div>
    <!-- 开通10个不能继续开通 -->
    <div class="tanchuang nokaitong" v-if="isNoopen">
      <div class="over">
        <img @click="guanbitc" class="right xs" src="/static/img/qiye/chahao.png" alt />
      </div>
      <div>
        <div class="tc-conent">
          <img src="/static/img/qiye/buneng kaitong@1x.png" alt />
        </div>
        <div class="tc-text">
          <p>您已开通了10个企业服务</p>
          <p>不能再继续开通服务</p>
        </div>
      </div>
    </div>

    <div style="display:flex;position:absolute;top:-68px;right:-23%;">
      <input
        v-model="searchValue"
        class="seach-input"
        placeholder="请输入公司名称"
        @keyup.enter="searchCompany"
        type="text"
      />
      <el-button @click="searchCompany" icon="el-icon-search"></el-button>
    </div>
    <div
      class="gs-qiyebox over"
      ref="qiyebox"
      :class="isheigh ? 'heigh' : ''"
      style="padding-bottom: 50px;"
    >
      <!-- <div class="gs-xiangqing dotted">
        <router-link to="/addenterprise">
          <div class="gs-tianja" @click="addEnterprise">
            <img src="/static/img/Fill 1.png" alt />
            <p>添加企业</p>
          </div>
        </router-link>
      </div>-->
      <div v-for="(d , i) in arr " :key="i" class="gs-xiangqing gs-list">
        <!-- 上 -->
        <div class="gs-shang">
          <el-dropdown v-if="d.saas_" trigger="hover" size="mini" placement="bottom-start">
            <img class="shezhi xs" src="/static/img/shezhi.png" alt="设置" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="d.default_">
                <span @click="hideDefaultWin(i)">取消默认</span>
              </el-dropdown-item>
              <el-dropdown-item v-else>
                <span @click="showDefaultWin(i)">设为默认</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="closeServer(i)">关闭服务</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <img v-if="d.default_" class="gs-morenimg" src="/static/img/moren2xL.png" alt />
        </div>
        <!-- 中 -->
        <div class="gs-xqleft">
          <!-- 点击查看企业详情 -->
          <p class="gs-qynema">
            <span @click="getEnterpriseInfo(d)" class="xs">{{d.name}}</span>
          </p>
          <p style="margin:16px 0px;">
            服务类型：
            <!-- <span>贸易云</span> -->
            <span>{{d.appId=="make-app"?"制造云":(d.appId=="trade-app"?"贸易云":"金融云")}}</span>
          </p>
        </div>
        <!-- 下 -->
        <div class="gs-xqright over">
          <div v-if="d.saas_" class="gs-xqright-left left" style="width:67%">
            <p>
              <span>管理员：</span>
              {{d.admin}}
            </p>
            <p>
              <span>联系方式：</span>
              {{d.adminMobile}}
            </p>
            <!-- <p><span>开通日期：</span></p> -->
          </div>
          <div class="gs-border gs-xqright-right right">
            <span v-if="d.saas_" class="gs-btn1 xs green" @click="selectServe(d)">进入使用</span>
            <span v-else @click="showOpenServeWin(d, i)" class="gs-btn1 kaitong xs blue">立即开通</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!searchStatus" style="text-align: center;">
      <el-pagination
        background
        :page-size="size"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="list.length"
      ></el-pagination>
    </div>
    <div v-else style="text-align: center;">
      <el-pagination
        background
        :page-size="searchSize"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="searchArrLength"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Session from "@/utils/session";
export default {
  data() {
    return {
      issetDefault: false, //设置默认
      isOpensaas: false, //开通saas弹窗
      isNoopen: false, //开通10个不能继续开通
      isokopensaas: false, //已开通服务
      index: 0,
      selected: {},
      saasindex: 0,
      ktsass: true, //开通saas
      isDefault: true, //开通默认
      isAutoLogin: this.$store.state.isAutoLogin,
      mytoken: Session.get(), //本地储存的用户信息
      list: [], //企业列表信息
      arr: [],
      isheigh: false, //是否添加默认高度
      admin: "",
      adminMobile: "",
      size: 12,

      storeList: [], //用于搜索框输入为空时重新拿到this.list的值
      searchArr: [], //用于分页函数
      searchValue: "", //搜索框输入框值
      searchArrLength: 0, //搜索框相关属性，用于控制分页栏
      searchSize: 0,
      searchStatus: false //控制不同分页器
    };
  },
  watch: {
    list: function() {
      this.$nextTick(function() {
        this.boxheight();
      });
    }
  },
  created() {
    let mytoken = Session.get();
    let token = String(mytoken.token);
    //企业列表
    this.$store.state.isloading = true;
    this.$ajax({
      url: this.$url.api + "/api/account/accountCenter/company/list", //http://192.168.253.41:8560
      method: "get",
      params: {
        mobile: mytoken.account.mobile
      },
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
      .then(res => {
        this.$store.state.isloading = false;
        if (res.data.success) {
          var dto = res.data.data;
          this.list = dto.spaces;
          this.storeList = dto.spaces;

          let a0 = this.list[0];   //最新注册企业排在默认企业前面
          this.list.shift();
          this.list.reverse();
          this.list.unshift(a0);

          this.pagingtion(1, this.size);
          let enterprise = [];
          let qyname = [];
          for (let i = 0; i < this.list.length; i++) {
            qyname.push(this.list[i].name);
            window.sessionStorage.setItem(
              "companyname",
              JSON.stringify(qyname)
            );
            if (this.list[i].saas_) {
              let addenterprise = { id: "", logoUrl: "", name: "", dcName: "" };
              addenterprise.id = this.list[i].id;
              addenterprise.logoUrl = this.list[i].logoUrl || null;
              addenterprise.name = this.list[i].name;
              addenterprise.dcName = this.list[i].dcName || null;
              enterprise.push(addenterprise);
            }
          }
          let session = Session.get();
          if (enterprise.length != session.account.companies.length) {
            session.account.companies = enterprise;
            Session.set(session);
          }
          let hasCompany = dto.hasDefaultCompany;
          let companyId = dto.defaultCompanyId;
          let token = dto.token.token;
          if (this.isAutoLogin) {
            if (hasCompany) {
              let session = Session.get();
              session.account.companyId = companyId;
              session.span = session.timestamp - new Date().getTime();
              session.token = token;
              window.location.href = this.$url.web.default[dto.appId || 'trade-app'];
            }
          }
          this.$store.commit("Loginfalse");
        } else {
          this.$message.error("获取企业列表信息失败，请重试");
        }
      })
      .catch(err => {
        // console.log("请求失败",err)
      });
  },
  mounted() {
    this.boxheight();
  },
  methods: {
    //分页
    handleCurrentChange(val) {
      $(document).scrollTop(0);
      if (!this.searchStatus) {
        this.pagingtion(val, this.size);
      } else {
        this.pagingtion(val, this.searchSize);
      }
    },
    //分页函数
    pagingtion(min, max) {
      //定义一个空数组存放分割的数据
      this.arr = [];
      let list;
      //对源数组进行分割
      if (!this.searchStatus) {
        list = this.list.concat().splice(min * max - max, max);
      } else {
        list = this.searchArr.concat().splice(min * max - max, max);
      }
      //循环插入新数组中进行展示
      for (let i = 0; i < list.length; i++) {
        this.arr.push(list[i]);
      }
    },
    //设置默认企业
    showDefaultWin(i) {
      this.index = i;
      this.issetDefault = true;
    },
    //确认默认企业
    setDefault() {
      let i = this.index;
      let token = this.mytoken.token;
      this.$ajax({
        url: this.$url.api + "/api/account/accountCenter/bind/defaultCompany",
        method: "post",
        data: {
          companyId: this.arr[i].id,
          accountId: this.mytoken.account.id
        },
        headers: {
          Authorization: token
        }
      }).then(res => {
        // console.log('请求成功',res);
        this.isDefault = false;
        this.$router.go(0);
      });
    },
    // 取消默认企业
    hideDefaultWin(i) {
      this.$store.state.isloading = true;
      let token = this.mytoken.token;
      this.$ajax({
        url: this.$url.api + "/api/account/accountCenter/unBind/defaultCompany",
        method: "post",
        data: {
          companyId: this.arr[i].id,
          accountId: this.mytoken.account.id
        },
        headers: {
          Authorization: token
        }
      })
        .then(res => {
          // this.$store.state.isloading = false;
          if (res.data.success) {
            this.$router.go(0);
          }
        })
        .catch(err => {
          // console.log('请求失败',err);
        });
    },
    //进入服务
    selectServe(company) {
      let token1 = this.mytoken.token;
      this.$ajax({
        url: this.$url.api + "/api/auth/switch/company?companyId=" + company.id,
        method: "get",
        headers: {
          Authorization: token1
        }
      })
        .then(res => {
          let authInfo = res.data.data, mytoken = authInfo.token;
          let session = Session.get();
          session.account.companyId = company.id;
          session.span = session.timestamp - new Date().getTime();
          session.token = mytoken;
          Session.set(session)
          window.location.href = this.$url.web[company.dcName || 'default'][company.appId || 'trade-app'];
        })
        .catch(err => {
          // console.log('请求失败',err)
        });
    },
    //开通saas服务开通数量达到10的时候禁止开通
    showOpenServeWin(company, i) {
      let saasNum = [];
      let list = this.list;
      for (let j = 0; j < list.length; j++) {
        if (list[j].saas_) {
          saasNum.push(list[j].saas_);
        }
      }
      if (saasNum.length >= 10) {
        this.isNoopen = true;
      } else {
        this.isOpensaas = true;
      }
      this.saasindex = i;
      this.selected = company;
    },
    confirmSaas() {
      //确认saas开通
      let i = this.saasindex;
      let token = this.mytoken.token;
      let qyname = this.list[i].name; //公司名字
      // TODO 让用户选择
      let appId = 'trade-app';
      this.$ajax({
        url: this.$url.api + "/api/account/accountCenter/register",
        method: "post",
        data: {
          companyName: this.list[i].name,
          userName: this.list[i].admin,
          mobile: this.list[i].adminMobile,
          appId
        },
        headers: {
          Authorization: token
        }
      })
        .then(res => {
          if (res.data.success) {
            this.$message.success('开通成功');
            let companyId = res.data.data[0];
            this.selected = {id: companyId, appId};
            this.ktsass = false;
            let name = qyname;
            let logoUrl = null;
            let addenterprise = { id: companyId, logoUrl: logoUrl, name: name };
            let session = Session.get();
            session.account.companies.push(addenterprise);
            Session.set(session);
            this.$router.go(0);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          // console.log('请求失败',err)
        });
    },
    //进入saas服务
    showServeWin() {
      this.isOpensaas = false;
      this.selectServe(this.selected);
    },
    //查看企业详情
    getEnterpriseInfo(d) {
      $(document).scrollTop(0);
      window.sessionStorage.setItem("content", JSON.stringify(d));
      this.$router.push({ path: "/details" });
    },
    //添加企业
    addEnterprise() {
      $(document).scrollTop(0);
    },
    //关闭弹窗
    guanbitc() {
      this.issetDefault = false;
      this.isOpensaas = false;
      this.isNoopen = false;
      this.isokopensaas = false;
    },
    //没有内容也要有一定的高度
    boxheight() {
      let H = this.$refs.qiyebox.offsetHeight;
      if (H < 500) {
        this.isheigh = true;
      } else {
        this.isheigh = false;
      }
    },
    //搜索框内容
    searchCompany: function() {
      if (this.searchValue == "") {
        //当输入框为空时
        this.arr = [];
        this.searchStatus = false;
        let list = this.storeList //对源数组进行分割
          .concat()
          .splice(1 * this.size - this.size, this.size);
        for (let i = 0; i < list.length; i++) {
          //循环插入新数组中进行展示
          this.arr.push(list[i]);
        }
      } else {
        //当输入框为不为空时
        this.arr = [];
        this.searchArr = [];
        this.searchStatus = true;
        this.list.forEach((item, index, array) => {
          if (item && item.name.indexOf(this.searchValue) != -1) {
            this.arr.push(item);
            this.searchArr.push(item);
          }
        });
        this.searchArrLength = this.arr.length;
        if (this.searchArrLength <= 12) {
          this.searchSize = this.searchArrLength;
        } else {
          this.searchSize = 12;
        }
        this.pagingtion(1, this.searchSize); //有值时初始化第一页
      }
    },
    closeServer: function(i) {
      var token = this.mytoken.token;
      var h = this.$createElement;
      this.$msgbox({
        title: "提醒",
        message: h("p", null, [h("span", null, "确认要关闭服务吗 ")]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.$ajax({
              url: this.$url.api + "/api/account/accountCenter/company/close",
              method: "get",
              params: {
                companyId: this.arr[i].id
              },
              headers: {
                Authorization: token,
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }).then(res => {
              if (res.data.success) {
                this.$router.go(0);
              }else{
                this.$message.error(res.data.message);
              }
            });
          } else {
            done();
          }
        }
      })
        .then(action => {
          this.$message({
            type: "info",
            message: "action: " + action
          });
        })
        .catch(e => e);
    }
  }
};
</script>

<style scoped>
.heigh {
  height: 500px;
}
.gs-xqright {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.gs-morentop {
  position: absolute;
  margin-top: 0px;
  left: 5px;
  display: none;
}
.gs-list {
  background-image: url(/static/img/list.png);
  background-position-x: 50%;
  background-position-y: 84%;
  background-size: 157%;
}
.green:hover {
  background: #2da74a;
}
.blue:hover {
  background: #0f6fd2;
}
.tc-context > p {
  font-size: 14px;
}
.el-dropdown {
  line-height: 25px;
}
.seach-input {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/conenter/company.vue